export default __webpack_public_path__ + "static/media/withoutDoneTasks.89706422.svg";